import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipService } from './tooltip/tooltip.service';
import { PruHttpService } from "../services/pru-http.service";
import { PrucarouselService } from '../services/prucarousel.service';
import { PruCarouselComponent } from '../component/pru-carousel/pru-carousel.component';
import { WcmdataComponent } from '../component/wcmdata/wcmdata.component';
import { HtmlTextService } from '../services/html-text.service';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { ModalService } from './modal/modal.service';
import { ModalComponent } from './modal/modal.component';
import { WindowRefService } from '../services/window-ref.service';
import { JsInterstitialService } from '../services/js-interstitial.service';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";


@NgModule({
  imports: [FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpModule,
    BrowserAnimationsModule
  ],
  providers: [
    PruHttpService,
    TooltipService,
    PrucarouselService,
    HtmlTextService,
    ModalService,
    WindowRefService,
    JsInterstitialService
  ],
  declarations: [
    TooltipComponent,
    PruCarouselComponent,
    WcmdataComponent,
    BackToTopComponent,
    ModalComponent
  ],
  exports: [
    TooltipComponent,
    PruCarouselComponent,
    WcmdataComponent,
    BackToTopComponent,
    ModalComponent
  ]
})
export class UtilitiesModule {
  constructor() {
  }
}
